// extracted by mini-css-extract-plugin
export default {"hideOverlayScrollbar":"Profile_hideOverlayScrollbar__jFjrQ"};